import { useState } from 'react';

/**
 * Returns a function, by calling it state will be updated and component will re-render
 */
export const useForceUpdate = () => {
    const [forceUpdateState, setValue] = useState(0);
    return {
        forceUpdate: () => setValue(value => value + 1),
        forceUpdateState,
    };
};
